import { render, staticRenderFns } from "./VisualizzaQuestionarioAssuntivo.vue?vue&type=template&id=0a64a306&"
import script from "./VisualizzaQuestionarioAssuntivo.vue?vue&type=script&lang=js&"
export * from "./VisualizzaQuestionarioAssuntivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerHourglass});
